export default "__VITE_ASSET__CinX9Exq__"